import { useHistory } from "react-router";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { createDokumenKerjasamaAsync, updateDokumenKerjasamaAsync } from "../../../reducers/dokumenKerjasama/dokumenKerjasama.actions";
import { PermissionMenuName } from "../../../interfaces/UserRole";
import { allowSave } from "../../../store/helpers";

export const FormValidasi = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector((state: RootState) => state.dokumenKerjasama.isLoading);
  const detailDokumenKerjasama = useSelector((state: RootState) => state.dokumenKerjasama.selectedDokumenKerjasama);
  const [isNew, setIsNew] = useState<boolean>(false);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.dokumenKerjasama].ACCESS);

  const canSave = allowSave(role, 2);

  useEffect(() => {
    const paths = history.location.pathname.split("/");
    if (paths[2] === 'create') setIsNew(true);
    else setIsNew(false);
  }, [history.location.pathname])

  const saveDocument = () => {
    if (detailDokumenKerjasama && !isLoading) {
      if (isNew) {
        dispatch(createDokumenKerjasamaAsync.request(detailDokumenKerjasama));
      } else {
        dispatch(updateDokumenKerjasamaAsync.request(detailDokumenKerjasama));
      }
    }
  }

  return (
    <React.Fragment>
      <div className="box">
        <div className="box-body">
          <div className="input-group">
            <span className="input-group-btn">
              <button type="button" className="btn btn-primary" style={{marginRight: '3px'}} onClick={() => history.push('/dokumen-kerjasama')}>
                Kembali
              </button>
              <button type="button" className="btn btn-primary" disabled={isLoading || !canSave} onClick={saveDocument}>
                Simpan Dokumen Kerjasama
              </button>
            </span>
          </div>
        </div>
        <div className="box-body">
          <p>Pastikan data yang diisi sudah benar. Pelaksana Kerjasama dan Partner Kerjasama yang telah ditambahkan tidak dapat diubah lagi.</p>
        </div>
        <div className={`overlay ${isLoading ? 'active' : null}`}>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );
};
